const showAccountSwitcher = _ref => {
  let {
    accounts,
    onAccountSearch,
    selectedAccount,
    showSingleAccount
  } = _ref;
  return showSingleAccount || selectedAccount && (accounts && accounts.length > 0 && (accounts.length > 1 || accounts[0].nestedAccounts && accounts[0].nestedAccounts.length > 0) || onAccountSearch);
};
export default showAccountSwitcher;